export const useIsDark = () => {
	function lightOrDark(color: string) {
		color = color.toString()
		let r, g, b

		if (color?.match(/^rgb/)) {
			color = color.match(
				/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
			)

			r = color[1]
			g = color[2]
			b = color[3]
		} else {
			r = parseInt(color.slice(1, 3), 16)
			g = parseInt(color.slice(3, 5), 16)
			b = parseInt(color.slice(5, 7), 16)
		}

		const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

		return hsp > 127.5
	}

	return {
		lightOrDark,
	}
}
